import {
  SET_SM_POPUP_FEEDBACK_DATA,
  RESET_SM_POPUP_FEEDBACK_DATA,
} from "./types";

export const setSmPopupFeedbackData = ({open, feedbackKey, metadata = {}, callback = null}) => {
  return {
    type: SET_SM_POPUP_FEEDBACK_DATA,
    payload: { open, feedbackKey, metadata, callback },
  };
};

export const resetSmPopupFeedbackData = () => {
  return {
    type: RESET_SM_POPUP_FEEDBACK_DATA,
  };
};
